import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import type { TFunction } from "i18next";
import * as yup from "yup";

dayjs.extend(customParseFormat);

export const parseYupDateString = (
  _: string,
  originalValue: string,
  format = "DD/MM/YYYY",
): false | Date | undefined => {
  if (originalValue === "") return undefined;

  return dayjs(originalValue, format, true).isValid() ? dayjs(originalValue, format).toDate() : false;
};

export const getPasswordSchema = (t: TFunction) =>
  yup
    .string()
    .required(t("ERRORS.COMMONS.REQUIRED"))
    .min(8, t("ERRORS.COMMONS.PASSWORD.TOO_SHORT"))
    .max(128, t("ERRORS.COMMONS.STRING_MAX_SIZE_EXCEEDED"))
    .matches(/^(?=.*[a-z]).+$/, t("ERRORS.COMMONS.PASSWORD.REQUIRE_SMALL_LETTER"))
    .matches(/^(?=.*[A-Z]).+$/, t("ERRORS.COMMONS.PASSWORD.REQUIRE_CAPITAL_LETTER"))
    .matches(/^(?=.*\d).+$/, t("ERRORS.COMMONS.PASSWORD.REQUIRE_NUMBER"))
    .matches(/^(?=.*?[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).+$/, t("ERRORS.COMMONS.PASSWORD.REQUIRE_SPECIAL_CHARACTER"));
